import React, { useRef, useState } from 'react';
import { AxiosProgressEvent } from 'axios';
import { authenticatedApi } from '../../Api/api';
import { IDocument } from '../../models/document';
import Styles from './styles.module.scss';
import { CircularProgress } from '@mui/material';

const FileUpload = ({
  uploadBtnDisabled = false,
  onUploadSuccess,
  uploadPath,
  uploadData = {},
  enableLabel = true,
  customData = {},
  children,
  renderChildren
}: {
  uploadBtnDisabled?: boolean;
  onUploadSuccess?: (newDocument: IDocument) => any;
  uploadPath?: string;
  uploadData?: any;
  enableLabel?: boolean;
  customData?: {[key: string]: any} | (({filename} : {filename: string} ) => {[key: string]: any});
  children?: React.ReactNode;
  renderChildren?: ({
    isUploading,
    uploadProgress
  }: {
    isUploading: boolean;
    uploadProgress: number;
  }) => React.ReactNode;
}) => {

  const [isUploading, setIsUploading] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [label, setLabel] = useState<string>('');
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [uploadProgress, setUploadProgress] = useState<number>(0);

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setSelectedFile(event.target.files[0]);
      setUploadProgress(0);
      console.log(event.target.files[0]);
    }
  };

  const onClickHandler = async () => {
    if (!selectedFile) {
      return;
    }
    setIsUploading(true);
    const data = new FormData();
    data.append('file', selectedFile);

    if (enableLabel) {
      data.append('label', label);
    }

    if (typeof customData === 'function') {
      Object.keys(customData({filename: selectedFile.name})).forEach((key) => {
        data.append(key, customData({filename: selectedFile.name})[key]);
      });
    } else {
      Object.keys(customData).forEach((key) => {
        data.append(key, customData[key]);
      });
    }

    Object.keys(uploadData).forEach((key) => {
      data.append(key, uploadData[key]);
    });

    try {
      const response = await authenticatedApi.post(uploadPath || '/documents/upload', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent: AxiosProgressEvent) => {
          console.log(progressEvent);
          if (!progressEvent) {
            return;
          }
          const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 100));
          setUploadProgress(percentCompleted);
        }
      });
      if (onUploadSuccess) {
        onUploadSuccess(response.data as IDocument);
        setLabel('');
        setSelectedFile(null);
        if (inputRef.current) {
          inputRef.current.value = '';
        }
        setTimeout(() => {
          setUploadProgress(0);
        }, 100);

      }
    } catch (error) {
      console.error('Error while uploading file: ', error);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className={Styles.uploadContainer}>

      <div className="mb-3">
        {/* <input class="form-control" type="file" id="formFile"> */}
        <input
          type="file" name="file"
          className="form-control"
          onChange={onChangeHandler} ref={inputRef}
        />
      </div>

      {enableLabel && (
        <div className="mb-3">
          {enableLabel && <label htmlFor="label">Label</label>}
          {enableLabel && <br/>}
          {enableLabel && (
            <input
              type="text"
              name="label"
              disabled={isUploading}
              value={label}
              onChange={(e) => setLabel(e.target.value)}
              //className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'
              className='tw-bg-gray-50 tw-border tw-border-gray-300 tw-text-gray-900 tw-text-sm tw-rounded-lg tw-focus:ring-blue-500 tw-focus:border-blue-500 tw-block tw-w-full tw-p-2.5'
            />
          )}
        </div>
      )}

      {children && (
      <div className="mb-3">
        {children}
      </div>
      )}
      {renderChildren && (
      <div className="mb-3">
        {renderChildren({
          isUploading: isUploading,
          uploadProgress
        })}
      </div>
      )}

      <div className="mb-3">
        {!isUploading && (
        <button
          type="button"
          disabled={uploadBtnDisabled || !selectedFile || isUploading || (enableLabel && label.length === 0)}
          className='btn btn-info' onClick={onClickHandler}>Upload</button>
        )}
        {isUploading && (
          <CircularProgress />
        )}
      </div>
      {uploadProgress > 0 && <p>Upload Progress: {uploadProgress}%</p>}
    </div>
  );
};

export default FileUpload;